
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const SelectedCheckCircleIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 21a9 9 0 0 1 0-18 9 9 0 1 1 0 18Z" clip-rule="evenodd"/><path stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M11.25 14.25 9 12M15 10.5l-3.75 3.75"/></svg>
  </SvgIcon>
);
